import { render, staticRenderFns } from "./customerPriceListConfig.vue?vue&type=template&id=57e011d6&"
import script from "./customerPriceListConfig.vue?vue&type=script&lang=js&"
export * from "./customerPriceListConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports